import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chips", "chip", "chipLabel", "chipInput", "template", "input"]

  static values = {
    maxLength: { type: Number, default: 30 }
  }

  add(event) {
    const name = this.cleanName(event.detail.textValue)

    this.inputTarget.value = ""

    if (!name || this.alreadySelected(name)) return

    const chip = this.templateTarget.content.cloneNode(true)

    chip.querySelector("[data-discussion-tags-target='chipLabel']").textContent = name
    chip.querySelector("[data-discussion-tags-target='chipInput']").value = name

    this.chipsTarget.appendChild(chip)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-discussion-tags-target='chip']").remove()
  }

  onKeydown(event) {
    if (event.key === "Enter") event.preventDefault()
  }

  cleanName(value) {
    return (value || "").trim().toLowerCase().replace(/\s+/g, " ").substring(0, this.maxLengthValue)
  }

  normalize(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }

  alreadySelected(name) {
    const normalized = this.normalize(name)

    return this.selectedNames().some((selected) => this.normalize(selected) === normalized)
  }

  selectedNames() {
    return Array.from(this.chipsTarget.querySelectorAll("input[type='hidden']"))
                .map((input) => input.value)
  }
}
